import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.sass']
})
export class ActionCardComponent implements OnInit {
  @Input() action: any;
  @Output() nameSearch = new EventEmitter<any>();
  @Output() monthSearch = new EventEmitter<any>();
  @Output() daySearch = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/components/action-card/action-card.component.ts